export default __webpack_public_path__ + "static/images/fangxiang-weapp.7b4ec6f1.png";